module.exports = __webpack_public_path__ + "1bebfd4719e60bbde477470bc866bef2.png";